module.exports = __webpack_public_path__ + "img/mb_hm_block03_02_sc.c46faf88.jpg";